<div *ngIf="!isServerError" class="header-box">
  <button [matMenuTriggerFor]="menu" class="no-style change-range">
    {{selectPeriodFilterItem.label}}
    <mat-icon [svgIcon]="'dropdown-arrow'" class="square-icon dropdown-arrow"></mat-icon>
  </button>

  <mat-menu #menu="matMenu" class="change-range-dropdown">
    <button *ngFor="let item of periodFilterItems" mat-menu-item [value]="item.value" (click)="periodChange(item.value)" [disabled]="isLoading">{{ item.label }}</button>
  </mat-menu>

  <h3 *ngIf="selectPeriodFilterItem && LocalizationService.showHebrewElements()" class="title">
    {{getDisplayRangeDate()[0] | date: 'd.M.yyyy'}} - {{getDisplayRangeDate()[1] | date: 'd.M.yyyy'}} | {{getHebrewDate(getDisplayRangeDate()[0])}} - {{getHebrewDate(getDisplayRangeDate()[1])}}
  </h3>
  <h3 *ngIf="selectPeriodFilterItem && !LocalizationService.showHebrewElements()" class="title">
    {{getDisplayRangeDate()[0] | date: 'd.M.yyyy'}} - {{getDisplayRangeDate()[1] | date: 'd.M.yyyy'}}
  </h3>
</div>

<div *ngIf="!isServerError" class="filters-search">
  <div class="filters mb-0">
    <mat-checkbox
      *ngFor="let item of typeFilterItems"
      class="radio-view"
      [ngStyle]="{'--control-color': FiltersColorHelper.getStyleColor(item.color)}"
      [checked]="item.checked"
      (change)="typeFilterChange($event, item.value, item.valueArr)"
      [disabled]="isLoading"
    >
      {{ item.label }}
    </mat-checkbox>
  </div>

  <mat-form-field appearance="outline" class="search-field mb-0">
    <input matInput [placeholder]="blockData.searchInputText" (input)="onKeySearch($event)" [disabled]="isLoading">
    <mat-icon matPrefix [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
  </mat-form-field>
</div>

<div *ngIf="!isServerError" class="mobile-filters">
  <div class="row">
    <div class="col period-filter-col">
      <app-filter-item
        #periodFilter
        filterTitle="תצוגה לפי"
        [filterItems]="periodFilterItems"
        (setValue)="mobilePeriodChange($event)"
      />
    </div>

    <div class="col type-filter-col">
      <app-filter-item
        #typeFilter
        filterTitle="תצוגה לפי"
        [filterItems]="typeFilterItems"
        [multi]="true"
        (setValue)="mobileTypeFilterChange($event)"
      />
    </div>
  </div>

  <div *ngIf="LocalizationService.showHebrewElements()" class="current-value">
    {{getDisplayRangeDate()[0] | date: 'd.M.yyyy'}} - {{getDisplayRangeDate()[1] | date: 'd.M.yyyy'}}|{{getHebrewDate(getDisplayRangeDate()[0])}} - {{getHebrewDate(getDisplayRangeDate()[1])}}
  </div>
  <div *ngIf="!LocalizationService.showHebrewElements()" class="current-value">
    {{getDisplayRangeDate()[0] | date: 'd.M.yyyy'}} - {{getDisplayRangeDate()[1] | date: 'd.M.yyyy'}}
  </div>
</div>

<div *ngIf="examsList.length > 0 && !isLoading && !isServerError" class="exams-list">
  <app-exam-item 
    *ngFor="let exam of examsList" 
    [data]="exam" 
    [studentCalendarFilters]="blockData.studentCalendarFilters" 
    (openPopup)="closeAllActivePopups()"
    [notificationsHeaderText]="blockData.lessonsNotificationsPopupHeaderText"
  ></app-exam-item>
</div>

<div *ngIf="examsList.length == 0 && !isLoading && !isServerError">
  <app-alert class="mb-2 alert-component" [icon]="'alert'" [textWidth]="'511px'" [innerHTML]="getNoResultsText()"></app-alert> 
  <img src="assets/imgs/schedule-not-registered.svg" class="schedule-image" width="246" height="238" alt="">
</div>

<div class="exams-list skeleton" *ngIf="isLoading && !isServerError">
  <app-skeleton class="exam-item" *ngFor="let _ of [].constructor(4)" [height]="80"/>
</div>

<app-timeout-error-message *ngIf="isServerError"/>